import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import apiService from '../../services/apiService';
import { ServiceDialog, CancelButton, NameTextField, ConfirmButton } from '../../styling/Styles';
import RowElement from '../BuildApps/DataElements/RowElement';

export default function DialogMembers({ open, setOpen, project, dispatch, setUpdateData }) {
  const [invitedMembers, setInvitedMembers] = useState(project.invited_people || []);
  const [members, setMembers] = useState(
    project.members.map((memberId) => ({ _id: memberId, name: '' })) || []
  );
  const [displayPendingInvitations, setDisplayPendingInvitations] = React.useState(false);
  const [displayMembers, setDisplayMembers] = React.useState(false);
  const [userName, setUserName] = useState('');
  const [ownerName, setOwnerName] = useState({ name: '', _id: '' });

  useEffect(() => {
    // This is a parallel for loop tread carefully
    if (open)
      Promise.all(members.map((member) => apiService.getUserWithParam({ _id: member._id })))
        .then((responses) =>
          responses.map((response) => ({ name: response.data.name, _id: response.data._id }))
        )
        .then((membersArray) => setMembers(membersArray))
        .catch((error) => {throw error;});
  }, [open]);

  useEffect(() => {
    setDisplayPendingInvitations(true);
    setDisplayMembers(true);
    setUserName('');
    if (project.invited_people === undefined) {
      setInvitedMembers([]);
    } else {
      setInvitedMembers(project.invited_people);
    }

    apiService
      .getUserWithParam({ _id: project.owner })
      .then((response) => setOwnerName({ name: response.data.name, _id: response.data._id }));
  }, [open]);

  
  const handleClose = () => {
    setOpen(false);
    setUpdateData(true);
  };

  const handleInvite = (userNa, id) => {
    const tempInvitedMembers = [...invitedMembers];
    tempInvitedMembers.push({ name: userNa, _id: id });
    setInvitedMembers(tempInvitedMembers);
    // TODO this need to change possible become a state
    project.invited_people = tempInvitedMembers;

    const inviterLogin = JSON.parse(localStorage.getItem('user')).login;

    apiService
      .updateProject2(project._id, { invited_people: tempInvitedMembers })
      .then((response) => {
        setInvitedMembers(response.data?.invited_people || []);
        return {
          inviteList: response.data?.invited_people,
          projectId: response.data._id,
          name: response.data.name
        };
      })
      .then((invitationObject) =>
        invitationObject.inviteList.filter( (user) => user._id === id).map((invite) => ({
          user: invite._id,
          action: {
            type: 'axiosRequest',
            config: {
              url: `${process.env.REACT_APP_SERVER_URL}/api/project/${invitationObject.projectId}/updateToMember`,
              method: 'PUT',
              params: { action: 'upgrade' }
            }
          },
          projectName: invitationObject.name,
          inviterLogin
        }))
      )
      .then((messages) =>
        Promise.all(messages.map((message) => {
          apiService.createMessage({ ...message })
          return 1;
        }
        ))
      )
      .catch((error) => {
        if (error.message === 'authentication failed') dispatch({ type: 'LOGOUT' });
      });
  };

  return (
    <ServiceDialog
      open={open}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <div style={{ height: '100%' }}>
        <div className={clsx('titlePopUp', 'paddingTitle')}>
          {' '}
          Edit project&apos;s members
          <div
            onClick={handleClose}
            className={clsx('gjs-mdl-btn-close')}
            style={{ fontSize: '2.2rem' }}
            data-close-modal=""
            aria-hidden="true"
          >
            ⨯
          </div>
        </div>
        <div
          className={clsx('paddingTitle')}
          style={{ height: '90%', overflowY: 'auto', maxHeight: '650px' }}
        >
          <RowElement
            label="Pending invitations"
            displayContent={displayPendingInvitations}
            setDisplayContent={setDisplayPendingInvitations}
            hideDelete
          />
          <div
            className={clsx('spacingTopDiv2', 'spacingLeftDiv', 'spacingRightDiv')}
            style={
              displayPendingInvitations !== true ? { display: 'none' } : { display: 'inherit' }
            }
          >
            <ShowMembers members={invitedMembers} ownerName={ownerName} project={project} isInvitations='true' setInvitedMembers={setInvitedMembers} setMembers={setMembers} />
          </div>

          <div className={clsx('spacingTopDiv2')}>
            <RowElement
              label="Members"
              displayContent={displayMembers}
              setDisplayContent={setDisplayMembers}
              hideDelete
            />
            <div
              className={clsx('spacingTopDiv', 'spacingLeftDiv', 'spacingRightDiv')}
              style={displayMembers !== true ? { display: 'none' } : { display: 'inherit' }}
            >
              <ShowMembers members={members} ownerName={ownerName} project={project}  isMembers='true' setInvitedMembers={setInvitedMembers} setMembers={setMembers}/>
            </div>
          </div>

          <div className={clsx('spacingTopDiv2')} style={{ marginLeft: '0.8vw' }}>
            <div className={clsx('flexRowDirection')}>
              <span className={clsx('boldBlue')}>Invite</span>
            </div>
            <div className={clsx('spacingTopDiv')}>
              <AddMemberPanel
                handleInvite={handleInvite}
                project={project}
                userName={userName}
                setUserName={setUserName}
                invitedMembers={invitedMembers}
              />
            </div>
          </div>
        </div>
      </div>
    </ServiceDialog>
  );
}

const ShowMembers = ({ members, ownerName, project,isInvitations, isMembers, setInvitedMembers, setMembers}) => {
  const memberNames = members.map((member) => (
    <div key={member._id} className={clsx('')} style={{marginTop: '0.5rem', display: 'flex',flexDirection: 'row', justifyContent: 'space-between'}}>
      {' '}
      <span style={{alignSelf: 'center' }}> {member.name} - <span style={{ fontStyle: 'italic' }}> Member</span> </span>

      { isInvitations === true && 
        <DeleteInvitation member={member} project={project} setInvitedMembers={setInvitedMembers}/>
      }
      { isMembers === true &&
        <DeleteMember member={member} project={project} setMembers={setMembers}/>
      }
      
    </div>
  ));
  return (
    <div style={{ marginLeft: '1vw' }}>
      {isMembers === true && (
        <div key={ownerName._id} className={clsx('')}>
          {' '}
          {ownerName.name} - <span style={{ color: '#E83C52', fontStyle: 'italic' }}>Owner</span>
        </div>
      )}
      <div>{memberNames}</div>{' '}
    </div>
  );
};

const DeleteMember = ({member, project, setMembers}) => {

  const deleteMember = () => {

    const members =  project.members.filter(mem => mem !== member._id).map(mem => mem);

    apiService
      .updateProject2(project._id, { members})
      .then(() => {
        setMembers(members)
      })
      .then( () =>{
        
        apiService
        .deleteMember({projectId: project._id, userId: member._id})
        .catch((error) => {throw error;});
      })
      .catch((error) => {throw error;});

  }

  return(
      <ConfirmButton onClick={deleteMember}>
        Delete member
      </ConfirmButton>
  )
}

const DeleteInvitation = ({member, project, setInvitedMembers}) => {

  const deleteInvitation = () => {

    const invitations = project.invited_people.filter( user => (user.name !== member.name && user._id !== member._id)).map(user => user);
    const inviterLogin = JSON.parse(localStorage.getItem('user')).login;
    const projectId = project._id;
    const memberId = member._id;

    apiService
      .updateProject2(project._id, { invited_people: invitations })
      .then(() => {
        setInvitedMembers(invitations);
      })
      .then(() =>{
        apiService
        .getInvitersMessages({ inviterLogin, projectName: project.name, user: memberId})
        .then(response => {

          response.data.forEach( (resp) =>{
            apiService
            .deleteUsersMessage({ userId: memberId, messageId: resp._id, projectId })
            .catch((error) => {throw error;});
          })
        })
        .catch((error) => {throw error;});
      })  
      .catch((error) => {throw error;});
      
  }

  return(
      <ConfirmButton onClick={deleteInvitation}>
        Delete invitation
      </ConfirmButton>
  )
}

const AddMemberPanel = ({
  handleInvite,
  project,
  userName,
  setUserName,
  invitedMembers
}) => {
  const [invitedMember, setInvitedMember] = useState({});

  useEffect(() => {
    let timeoutId = null;
    if (userName) {
      timeoutId = setTimeout(
        () =>
          apiService
            .getUserWithParam({ name: userName })
            .then((response) =>
              setInvitedMember({ name: response.data.name, _id: response.data._id })
            ),
        1000
      );
    }
    return () => clearTimeout(timeoutId);
  }, [userName]);

  const notItself = () => {
    let exists = false;

    const tempUser = JSON.parse(localStorage.getItem('user'));

    if (userName === tempUser.login) {
      exists = true;
    }
    return exists;
  };

  const notAgain = () => {
    let exists = false;

    project.members.forEach((memberId) => {
      if (memberId === invitedMember._id) {
        exists = true;
      }
    });
    return exists;
  };

  const findExistingPendingInvitations = () => {
    let exists = false;

    invitedMembers.forEach( (user) => {
      if(user._id === invitedMember._id) {
        exists = true;
      }
    })

    return exists;

  }

  const handleUserInput = (event) => {
    setUserName(event.target.value);
  };

  const clearField = () => {
    setUserName('');
    setInvitedMember({});
  };

  const inviteUser = () => {
    handleInvite(userName, invitedMember._id);
    clearField();
  };

  const returnHelperText = () => {
    if(!invitedMember._id && userName !== ''){
      return 'Not found';
    }
    if(notItself() === true){
      return 'Can not assign to yourself';
    }
    if(notAgain() === true && userName !== '' ){
      return 'Already assigned to this user'
    }
    if(findExistingPendingInvitations() === true){
      return 'A pending invitation exists for this user';
    }
    return '';
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <NameTextField
        id="outlined-name"
        placeholder=" user name"
        value={userName}
        onChange={handleUserInput}
        error={
          (!invitedMember._id && userName !== '') ||
          notItself() === true ||
          notAgain() === true || 
          findExistingPendingInvitations() === true
        }
        helperText={ returnHelperText()}
      />
      <div style={{ marginLeft: '2vw' }}>
        {invitedMember._id && notItself() === false && notAgain() === false &&  findExistingPendingInvitations() === false && (
          <ConfirmButton onClick={inviteUser}>Invite</ConfirmButton>
        )}
        {userName !== '' && (
          <CancelButton onClick={clearField} style={{ marginLeft: '1vw' }}>
            Clear
          </CancelButton>
        )}
      </div>
    </div>
  );
};
